import { useEffect } from 'react';

// Once the cancel time frame closes, the entry transitions from cancellable to cashout-eligible
// A refetch at that moment picks up the updated state from the server.
export const useCancelExpiryRefetch = (expiry: number | null, callback: () => void) => {
    useEffect(() => {
        if (!expiry) {
            return;
        }
        const delay = Math.max(0, expiry - Date.now());
        const timer = setTimeout(callback, delay);
        return () => clearTimeout(timer);
    }, [expiry, callback]);
};
